import React from 'react';
import { QueueCard } from '../types/types';
import { CARD_ICONS } from '../utils/cardConstants';
import '../styles/CardQueue.css';

// Import all HP icons
import glassesIcon from '../assets/hp_icons/glasses.png';
import hatIcon from '../assets/hp_icons/hat.png';
import scrollIcon from '../assets/hp_icons/scroll.png';
import owlIcon from '../assets/hp_icons/owl.png';
import letterIcon from '../assets/hp_icons/letter.png';
import timeturnerIcon from '../assets/hp_icons/timeturner.png';
import wandIcon from '../assets/hp_icons/wand.png';
import beerIcon from '../assets/hp_icons/beer.png';
import bookIcon from '../assets/hp_icons/book.png';
import goldenSnitchIcon from '../assets/hp_icons/golden-snitch.png';
import cauldronIcon from '../assets/hp_icons/cauldron.png';
import scarfIcon from '../assets/hp_icons/scarf.png';
import hogwartsCrestIcon from '../assets/hp_icons/hogwarts-crest.png';
import potionIcon from '../assets/hp_icons/potion.png';

// Map icon types to their image files
const iconImages: Record<string, string> = {
  'glasses': glassesIcon,
  'hat': hatIcon,
  'scroll': scrollIcon,
  'owl': owlIcon,
  'letter': letterIcon,
  'timeturner': timeturnerIcon,
  'wand': wandIcon,
  'beer': beerIcon,
  'book': bookIcon,
  'golden-snitch': goldenSnitchIcon,
  'cauldron': cauldronIcon,
  'scarf': scarfIcon,
  'hogwarts-crest': hogwartsCrestIcon,
  'potion': potionIcon
};

interface CardQueueProps {
  cards: QueueCard[];
  position: 'left' | 'right';
  onCardClick: (card: QueueCard) => void;
}

const CardQueue: React.FC<CardQueueProps> = ({ cards, position, onCardClick }) => {
  const handleClick = () => {
    if (cards.length > 0) {
      onCardClick(cards[0]);
    }
  };

  // Determine how many "stack" cards to show (max 5)
  const stackCount = Math.min(cards.length, 5);
  
  // Empty queue state
  if (cards.length === 0) {
    return (
      <div className={`card-queue ${position} empty`}>
        <div className="card-stack-container empty">
          <div className="empty-queue-message">Empty</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`card-queue ${position}`}>
      <div className="card-stack-container">
        {/* Render stack of cards in the background */}
        {Array.from({ length: stackCount }).map((_, index) => (
          <div 
            key={`stack-${index}`} 
            className="stack-card" 
            style={{ 
              transform: `translateY(${index * 3}px)`,
              zIndex: 10 - index
            }}
          />
        ))}
        
        {/* Top card (clickable with icon) */}
        <div 
          className="queue-card" 
          onClick={handleClick}
          style={{ 
            transform: stackCount > 0 ? `translateY(-5px)` : 'none',
            zIndex: 20
          }}
        >
          <div className={`queue-card-icon ${CARD_ICONS[cards[0].type % CARD_ICONS.length]}`}>
            <img 
              src={iconImages[CARD_ICONS[cards[0].type % CARD_ICONS.length]]} 
              alt={CARD_ICONS[cards[0].type % CARD_ICONS.length]} 
              className="queue-card-icon-image" 
            />
          </div>
        </div>
      </div>
      
      {/* Card count badge */}
      <div className="card-count-badge">
        {cards.length}
      </div>
    </div>
  );
};

export default CardQueue; 